// @ts-ignore
import { Notifications } from 'store/records/notifications'
import * as types from './actionTypes'
import { fromJS, Map } from 'immutable'

import { INotificationsRecord } from './interface'

export const initialState = new Notifications()

function setNotificationsToState(state: INotificationsRecord, payload: any) {
  const notifications = fromJS(payload.data.data)
  return state
    .setIn(['pending', 'getNotifications'], false)
    .setIn(['loaded', 'getNotifications'], true)
    .set('notifications', notifications as any)
    .set('notificationsPagination', Map(payload.data.pagination) as any)
}

function setNotificationsLoadMoreToState(state: INotificationsRecord, payload: any) {
  const newNotifications = fromJS(payload.data.data) as any
  const notifications = state.get('notifications').concat(newNotifications)
  return state
    .setIn(['pending', 'getNotificationsLoadMore'], false)
    .setIn(['loaded', 'getNotificationsLoadMore'], !newNotifications.size)
    .set('notifications', notifications)
    .set('notificationsPagination', Map(payload.data.pagination) as any)
}

function createEventNotification(state: INotificationsRecord, payload: any) {
  const count = state.get('unreadCount') + 1
  state = state.set('unreadCount', count)
  return state.update('notifications', notifications => notifications.unshift(fromJS(payload)))
}

function updateReaction(state: INotificationsRecord, payload: any) {
  const reactionIndex = state.get('notifications').findIndex(item => item.get('id') === payload.id && item.get('emoji'))
  return state.setIn(['notifications', reactionIndex], fromJS(payload))
}

function markNotificationsRead(state: INotificationsRecord) {
  return state.set('unreadCount', 0)
}

const notificationsReducer = (state = initialState, action: any) => {
  const { type, payload } = action

  switch (type) {
    case types.NOTIFICATIONS_ENABLE_GET_PENDING: {
      return state.setIn(['pending', 'getNotifications'], true)
    }
    case types.NOTIFICATIONS_ENABLE_LOAD_MORE_PENDING: {
      return state.setIn(['pending', 'getNotificationsLoadMore'], true)
    }
    case types.NOTIFICATIONS.GET.SUCCESS: {
      return setNotificationsToState(state as INotificationsRecord, payload)
    }
    case types.NOTIFICATIONS_LOAD_MORE.GET.SUCCESS: {
      return setNotificationsLoadMoreToState(state as INotificationsRecord, payload)
    }
    case types.NOTIFICATIONS_MARKED_READ.GET.SUCCESS: {
      return markNotificationsRead(state as INotificationsRecord)
    }
    case types.NOTIFICATIONS_UNREAD_COUNT.GET.SUCCESS: {
      return state.set('unreadCount', payload.data.unreadCount)
    }
    case types.REACTION_CREATED: {
      return createEventNotification(state as INotificationsRecord, payload)
    }
    case types.REACTION_UPDATED: {
      return updateReaction(state as INotificationsRecord, payload)
    }
    case types.MENTION_CREATED: {
      return createEventNotification(state as INotificationsRecord, payload)
    }
    case types.PEER_INVITE_ACCEPTED: {
      return createEventNotification(state as INotificationsRecord, payload)
    }
    default:
      return state
  }
}

export default notificationsReducer
